
import { IKeHoachMonActionTypes } from "../../action-types/ke-hoach/IKeHoachMonActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachMonReducer } from "../../reducer-model/ke-hoach/IKeHoachMonReducer";
const iniState: IKeHoachMonReducer = {
  status: eReducerStatusBase.is_not_initialization,
  keHoachLops: [],
  idKh: 0,
  hoc_ky: 0,
  keHoachMons: [],
  addingMon: {
    monHocSelectedIds: [],
    nhomLopId: 0
  },
  keHoachMonChiTiets: [],
  keHoachMonSelectedIds: [],
  ganGiaiDoan: {
    nhomLopId: 0,
    isOpenModal: false
  },
  copyKeHoach: {
    nhomLopId: 0,
    isOpenModal: false,
    nhomLopPateIds: []
  }
};
export const keHoachMonReducer = (
  state: IKeHoachMonReducer = iniState,
  action: IKeHoachMonActionTypes
): IKeHoachMonReducer => {
  switch (action.type) {
    case "KE_HOACH_MON_KE_HOACH_LOP_LOAD_START":
      return {
        ...state
      };
    case "KE_HOACH_MON_KE_HOACH_LOP_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachLops: action.payload,
      };
    case "KE_HOACH_MON_KE_HOACH_LOP_LOAD_ERRR":
      return {
        ...state,
      };
    case "KE_HOACH_MON_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KE_HOACH_MON_LOAD_NHOMLOP_FULL_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KE_HOACH_MON_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: action.payload,
      };
    case "KE_HOACH_MON_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KE_HOACH_MON_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        status: eReducerStatusBase.is_need_reload
      }

    case "KE_HOACH_MON_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      }
    case "KE_HOACH_MON_DELETE_SUCCESS":
      const ids = action.payload;
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMonSelectedIds: [],
        keHoachMons: [...state.keHoachMons.filter(x => !ids.includes(x.id_kh_mon))]
      }
    case "KE_HOACH_MON_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "KE_HOACH_MON_SHOW_ADD_MON_MODAL":
      return {
        ...state,
        addingMon: {
          nhomLopId: action.payload,
          monHocSelectedIds: []
        }
      }
    case "KE_HOACH_MON_CLOSE_ADD_MON_MODAL":
      return {
        ...state,
        addingMon: {
          nhomLopId: 0,
          monHocSelectedIds: []
        }
      }
    case "KE_HOACH_MON_CHANGE_ADD_MON_SELECTED_IDS": {
      return {
        ...state,
        addingMon: {
          ...state.addingMon,
          monHocSelectedIds: action.payload
        }
      }
    }
    case "KE_HOACH_MON_ADDING_MONHOC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      }
    case "KE_HOACH_MON_ADDING_MONHOC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        addingMon: {
          ...state.addingMon,
          nhomLopId: 0
        }
      }
    case "KE_HOACH_MON_ADDING_MONHOC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "KE_HOACH_MON_LOAD_CHITIET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      }
    case "KE_HOACH_MON_LOAD_CHITIET_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMonChiTiets: action.payload
      }
    case "KE_HOACH_MON_LOAD_CHITIET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "KE_HOACH_MON_SAVE_CHITIET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      }
    case "KE_HOACH_MON_SAVE_CHITIET_SUCCESS":
      const id_kh_mon_cts = action.payload.map(x => x.id_kh_mon_ct);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMonChiTiets: [...state.keHoachMonChiTiets.filter(x => !id_kh_mon_cts.includes(x.id_kh_mon_ct)), ...action.payload]
      }
    case "KE_HOACH_MON_SAVE_CHITIET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "KE_HOACH_MON_DELETE_CHITIET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      }
    case "KE_HOACH_MON_DELETE_CHITIET_SUCCESS":
      const id_kh_mon_cts_deleted = action.payload;
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMonChiTiets: state.keHoachMonChiTiets.filter(x => !id_kh_mon_cts_deleted.includes(x.id_kh_mon_ct))
      }
    case "KE_HOACH_MON_DELETE_CHITIET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "KE_HOACH_MON_CHANGE_KE_HOACH_MON_SELECTED_IDS":
      return {
        ...state,
        keHoachMonSelectedIds: action.payload
      }
    case "KE_HOACH_MON_UPDATE_GIAI_DOAN_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_UPDATE_GIAI_DOAN_SUCCESS":
      const id_kh_mon_changeds = action.payload.keHoachMons.map(x => x.id_kh_mon);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        ganGiaiDoan: {
          ...state.ganGiaiDoan,
          isOpenModal: false
        },
        keHoachMons: state.keHoachMons.map(keHoachMon => {
          const newData = action.payload.keHoachMons.find(x => x.id_kh_mon === keHoachMon.id_kh_mon)
          if (newData) {
            return newData;
          }
          return keHoachMon;
        }),
        keHoachMonChiTiets: [
          ...state.keHoachMonChiTiets.filter(x => !id_kh_mon_changeds.includes(x.id_kh_mon)),
          ...(action.payload.keHoachMonChiTiets ?? [])
        ]
      }
    case "KE_HOACH_MON_UPDATE_GIAI_DOAN_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "KE_HOACH_MON_UPDATE_GAN_GIAI_DOAN":
      return {
        ...state,
        ganGiaiDoan: action.payload
      }
    case "KE_HOACH_MON_UPDATE_COPY_KEHOACH":
      return {
        ...state,
        copyKeHoach: action.payload
      }
    case "KE_HOACH_MON_COPY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_COPY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        copyKeHoach: {
          ...state.copyKeHoach,
          isOpenModal: false
        }
      }
    case "KE_HOACH_MON_COPY_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    default:
      return state;
  }
};
